var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5675 0.0585938H0.433748C0.227498 0.0585938 0.0599976 0.226094 0.0599976 0.432344V15.5661C0.0599976 15.7711 0.227498 15.9398 0.433748 15.9398H15.5675C15.7725 15.9398 15.9412 15.7711 15.9412 15.5661V0.432344C15.94 0.227344 15.7712 0.0585938 15.5675 0.0585938ZM15.0175 15.0173H0.982498V0.981094H15.0175V15.0173Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.3f1eaaa6c75f4f20af785eadd4018871.svg";
export { ForwardRef as ReactComponent };